require("-!/home/runner/work/redux-frontend/redux-frontend/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/home/runner/work/redux-frontend/redux-frontend/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/home/runner/work/redux-frontend/redux-frontend/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 1468
// module chunks = 47